'use strict';

export function initFaqToggle() {
  // Function to open a specific accordion item
  function openAccordion(item) {
    const content = item.querySelector('.faq-content');
    const icon = item.querySelector('.faq-icon');

    item.classList.add('is-open');
    content.style.maxHeight = content.scrollHeight + 'px';
    icon.textContent = '−';
  }

  // Function to close a specific accordion item
  function closeAccordion(item) {
    const content = item.querySelector('.faq-content');
    const icon = item.querySelector('.faq-icon');

    item.classList.remove('is-open');
    content.style.maxHeight = null;
    icon.textContent = '+';
  }

  // Function to close all accordion items
  function closeAllAccordions() {
    document.querySelectorAll('.faq-item').forEach(el => {
      closeAccordion(el);
    });
  }

  // Check URL hash on page load
  function checkHashOnLoad() {
    const hash = window.location.hash.substring(1); // Remove '#'
    if (hash) {
      const targetItem = document.getElementById(hash);
      if (targetItem && targetItem.classList.contains('faq-item')) {
        closeAllAccordions();
        openAccordion(targetItem);

        // Scroll to the item smoothly
        setTimeout(() => {
          targetItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }

  // Add click listeners to all FAQ toggles
  document.querySelectorAll('.faq-toggle').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');
      const itemId = item.id;

      // Close all accordions
      closeAllAccordions();

      // Open current if it was closed
      if (!isOpen) {
        openAccordion(item);

        // Update URL hash without scrolling
        if (itemId) {
          history.pushState(null, null, `#${itemId}`);
        }
      } else {
        // If closing, remove hash from URL
        history.pushState(null, null, window.location.pathname);
      }
    });
  });

  // Handle browser back/forward buttons
  window.addEventListener('hashchange', () => {
    checkHashOnLoad();
  });

  // Check hash on initial load
  checkHashOnLoad();
}
